export default __webpack_public_path__ + "static/media/117.0a26fb98.png";